import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../assets/css/main.css";
import "./Home.css";
import { Link } from "react-router-dom";
import IPDALogo from "../assets/img/IPDALogo.png";
import { FaPhoneAlt } from "react-icons/fa";

const Navbar = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [openDropdowns, setOpenDropdowns] = useState({});

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  const toggleDropdown = (key) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <>
      <div className="index-page">
        <header
          id="header"
          className="header d-flex align-items-center position-relative"
          style={{ backgroundColor: "white" }}
        >
          <div className="container-fluid container-xl position-relative d-flex align-items-center justify-content-between">
            <a href="/" className="logo d-flex align-items-center">
              <img src={IPDALogo} alt="AgriCulture" />
            </a>

            {/* Desktop Navigation */}
            <nav id="navmenu" className="navmenu d-none d-lg-block">
              <ul>
                <li>
                  <a href="/" className="active">
                    Home
                  </a>
                </li>

                <li className="dropdown">
                  <a href="#">
                    <span>About Us</span>{" "}
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </a>
                  <ul style={{ backgroundColor: "#fff5e6" }}>
                    <li>
                      <Link to="/about-csc" style={{ color: "#d4561a" }}>
                        About CSC
                      </Link>
                    </li>
                    <li>
                      <Link to="/collobration" style={{ color: "#d4561a" }}>
                        Our Collaboration
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-mandates" style={{ color: "#d4561a" }}>
                        Our Mandates
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/strategic-interventions"
                        style={{ color: "#d4561a" }}
                      >
                        Strategic Interventions
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/pioneering-member-council"
                        style={{ color: "#d4561a" }}
                      >
                        Pioneering Members of the Council
                      </Link>
                    </li>
                  </ul>
                </li>

                {/* <li className="dropdown">
                  <a href="#">
                    <span>Growers</span>{" "}
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </a>
                  <ul style={{ backgroundColor: "#fff5e6" }}>
                    <li>
                      <Link to="/seeds-inputs" style={{ color: "#d4561a" }}>
                        Seeds, Inputs
                      </Link>
                    </li>
                    <li>
                      <a
                        href="/pest-managment-diseases"
                        style={{ color: "#d4561a" }}
                      >
                        Pest Management & Diseases
                      </a>
                    </li>
                    <li>
                      <a
                        href="/post-harvest-managment"
                        style={{ color: "#d4561a" }}
                      >
                        Post Harvest Management
                      </a>
                    </li>
                  </ul>
                </li> */}

                <li className="dropdown">
                  <a href="#">
                    <span>Knowledge Centre</span>{" "}
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </a>
                  <ul style={{ backgroundColor: "#fff5e6" }}>
                    <li>
                      <a href="/about-commodity" style={{ color: "#d4561a" }}>
                        About Commodity (Variety Information)
                      </a>
                    </li>
                    <li>
                      <a
                        href="/standard-practices"
                        style={{ color: "#d4561a" }}
                      >
                        Standard Package of Practices
                      </a>
                    </li>
                    <li>
                      <a
                        href="/regulations-policy"
                        style={{ color: "#d4561a" }}
                      >
                        Regulations & Policy
                      </a>
                    </li>
                    <li>
                      <a href="/production-data" style={{ color: "#d4561a" }}>
                        Production Data
                      </a>
                    </li>
                    <li>
                      <a
                        href="/import-export-data"
                        style={{ color: "#d4561a" }}
                      >
                        Import & Export Data
                      </a>
                    </li>
                  </ul>
                </li>

                <li className="dropdown">
                  <a href="#">
                    <span>Members Information Centre</span>{" "}
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </a>
                  <ul style={{ backgroundColor: "#fff5e6" }}>
                    <li>
                      <a
                        href="/sectoral-seminar-training"
                        style={{ color: "#d4561a" }}
                      >
                        Sectoral Seminars/Workshops
                      </a>
                    </li>
                    <li>
                      <a href="/policy-meetings" style={{ color: "#d4561a" }}>
                        Policy Dialogue Group Meetings
                      </a>
                    </li>
                    <li>
                      <a
                        href="/training-knowledge-exchange"
                        style={{ color: "#d4561a" }}
                      >
                        Training and Knowledge Exchange
                      </a>
                    </li>
                    <li>
                      <a href="/national-events" style={{ color: "#d4561a" }}>
                        National Event Participation
                      </a>
                    </li>
                    <li>
                      <a
                        href="/international-events"
                        style={{ color: "#d4561a" }}
                      >
                        International Event Participation
                      </a>
                    </li>
                  </ul>
                </li>

                {/* <li className="dropdown">
                  <a href="#">
                    <span>Updates</span>{" "}
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </a>
                  <ul style={{ backgroundColor: "black" }}>
                    <li>
                      <a href="/exposure-visits" style={{ color: "#d4561a" }}>
                        Exposure Visits
                      </a>
                    </li>
                    <li>
                      <a href="/webinars" style={{ color: "#d4561a" }}>
                        Webinars
                      </a>
                    </li>
                    <li>
                      <a href="/national-events" style={{ color: "#d4561a" }}>
                        National Events
                      </a>
                    </li>
                    <li>
                      <a
                        href="/seminar-workshops-trainings"
                        style={{ color: "#d4561a" }}
                      >
                        Seminars & Trainings
                      </a>
                    </li>
                    <li>
                      <a
                        href="/international-events"
                        style={{ color: "#d4561a" }}
                      >
                        International Events
                      </a>
                    </li>
                  </ul>
                </li> */}

                <li className="dropdown">
                  <a href="#">
                    <span>PR & Media</span>{" "}
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </a>
                  <ul style={{ backgroundColor: "#fff5e6" }}>
                    <li>
                      <a href="/news-letters" style={{ color: "#d4561a" }}>
                        Newsletter
                      </a>
                    </li>
                    <li>
                      <a href="/articles" style={{ color: "#d4561a" }}>
                        Articles
                      </a>
                    </li>
                    <li>
                      <a href="/videos" style={{ color: "#d4561a" }}>
                        Videos
                      </a>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/join-us">Join Us</Link>
                </li>

                <li className="ms-auto contact-icon">
                  <Link to="/contact-us">
                    <FaPhoneAlt className="contact-icon" />
                    <span className="tooltip">Contact Us</span>
                  </Link>
                </li>
              </ul>
            </nav>

            {/* Mobile Sidebar Toggle Button */}
            <button
              className="mobile-nav-toggle d-lg-none btn"
              onClick={toggleSidebar}
            >
              <i className="bi bi-list fs-2"></i>
            </button>
          </div>
        </header>

        {/* Mobile Sidebar */}
        <div className={`mobile-sidebar ${isSidebarOpen ? "open" : ""}`}>
          <button className="close-btn" onClick={closeSidebar}>
            <i className="bi bi-x-lg"></i>
          </button>
          <ul>
            <li>
              <Link to="/" onClick={closeSidebar}>
                Home
              </Link>
            </li>

            {/* About Us */}
            <li>
              <button
                onClick={() => toggleDropdown("about")}
                className="dropdown-toggle-btn"
              >
                About Us{" "}
                <span className="arrow">{openDropdowns.about ? "▼" : "▶"}</span>
              </button>

              {openDropdowns.about && (
                <ul className="mobile-submenu">
                  <li>
                    <Link to="/about-csc" onClick={closeSidebar}>
                      About CSC
                    </Link>
                  </li>
                  <li>
                    <Link to="/collobration" onClick={closeSidebar}>
                      Our Collaboration
                    </Link>
                  </li>
                  <li>
                    <Link to="/our-mandates" onClick={closeSidebar}>
                      Our Mandates
                    </Link>
                  </li>
                  <li>
                    <Link to="/strategic-interventions" onClick={closeSidebar}>
                      Strategic Interventions
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/pioneering-member-council"
                      onClick={closeSidebar}
                    >
                      Pioneering Members of the Council
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Growers */}
            {/* <li>
              <button
                onClick={() => toggleDropdown("growers")}
                className="dropdown-toggle-btn"
              >
                Growers{" "}
                <span className="arrow">
                  {openDropdowns.growers ? "▼" : "▶"}
                </span>
              </button>

              {openDropdowns.growers && (
                <ul className="mobile-submenu">
                  <li>
                    <Link to="/seeds-inputs" onClick={closeSidebar}>
                      Seeds, Inputs
                    </Link>
                  </li>
                  <li>
                    <Link to="/pest-managment-diseases" onClick={closeSidebar}>
                      Pest Mgmt & Diseases
                    </Link>
                  </li>
                  <li>
                    <Link to="/post-harvest-managment" onClick={closeSidebar}>
                      Post Harvest
                    </Link>
                  </li>
                </ul>
              )}
            </li> */}

            {/* Knowledge Centre */}
            <li>
              <button
                onClick={() => toggleDropdown("knowledge")}
                className="dropdown-toggle-btn"
              >
                Knowledge Centre{" "}
                <span className="arrow">
                  {openDropdowns.knowledge ? "▼" : "▶"}
                </span>
              </button>

              {openDropdowns.knowledge && (
                <ul className="mobile-submenu">
                  <li>
                    <Link to="/about-commodity" onClick={closeSidebar}>
                      Commodity Info
                    </Link>
                  </li>
                  <li>
                    <Link to="/standard-practices" onClick={closeSidebar}>
                      Practices
                    </Link>
                  </li>
                  <li>
                    <Link to="/regulations-policy" onClick={closeSidebar}>
                      Policies
                    </Link>
                  </li>
                  <li>
                    <Link to="/production-data" onClick={closeSidebar}>
                      Production Data
                    </Link>
                  </li>
                  <li>
                    <Link to="/import-export-data" onClick={closeSidebar}>
                      Import/Export
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Consumers Info */}
            <li>
              <button
                onClick={() => toggleDropdown("consumers")}
                className="dropdown-toggle-btn"
              >
                Consumers Info{" "}
                <span className="arrow">
                  {openDropdowns.consumers ? "▼" : "▶"}
                </span>
              </button>

              {openDropdowns.consumers && (
                <ul className="mobile-submenu">
                  <li>
                    <Link to="/awareness-campaign" onClick={closeSidebar}>
                      Awareness
                    </Link>
                  </li>
                  <li>
                    <Link to="/sectoral-reports" onClick={closeSidebar}>
                      Reports
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Updates */}
            <li>
              <button
                onClick={() => toggleDropdown("updates")}
                className="dropdown-toggle-btn"
              >
                Members Information Center{" "}
                <span className="arrow">
                  {openDropdowns.updates ? "▼" : "▶"}
                </span>
              </button>
              {openDropdowns.updates && (
                <ul className="mobile-submenu">
                  <li>
                    <a
                      href="/sectoral-seminar-training"
                      style={{ color: "#d4561a" }}
                    >
                      Sectoral Seminars/Workshops
                    </a>
                  </li>
                  <li>
                    <a href="/policy-meetings" style={{ color: "#d4561a" }}>
                      Policy Dialogue Group Meetings
                    </a>
                  </li>
                  <li>
                    <a
                      href="/training-knowledge-exchange"
                      style={{ color: "#d4561a" }}
                    >
                      Training and Knowledge Exchange
                    </a>
                  </li>
                  <li>
                    <a href="/national-events" style={{ color: "#d4561a" }}>
                      National Event Participation
                    </a>
                  </li>
                  <li>
                    <a
                      href="/international-events"
                      style={{ color: "#d4561a" }}
                    >
                      International Event Participation
                    </a>
                  </li>
                </ul>
              )}
            </li>

            {/* PR & Media */}
            <li>
              <button
                onClick={() => toggleDropdown("media")}
                className="dropdown-toggle-btn"
              >
                PR & Media{" "}
                <span className="arrow">{openDropdowns.media ? "▼" : "▶"}</span>
              </button>
              {openDropdowns.media && (
                <ul className="mobile-submenu">
                  <li>
                    <Link to="/news-letters" onClick={closeSidebar}>
                      Newsletter
                    </Link>
                  </li>
                  <li>
                    <Link to="/articles" onClick={closeSidebar}>
                      Articles
                    </Link>
                  </li>
                  <li>
                    <Link to="/videos" onClick={closeSidebar}>
                      Videos
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li>
              <Link to="/join-us">Join Us</Link>
            </li>

            {/* Contact */}
            <li>
              <Link to="/contact-us" onClick={closeSidebar}>
                Contact Us {""}
                <FaPhoneAlt />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;
